export var CheggEnv = /*#__PURE__*/function (CheggEnv) {
  CheggEnv["DEV"] = "dev";
  CheggEnv["TEST"] = "test";
  CheggEnv["STAGE"] = "stage";
  CheggEnv["PROD"] = "prod";
  return CheggEnv;
}({});
// Grabs process.env.CHEGG_ENV and returns undefined value if it is not in the enum
// CHEGG_ENV is a build time only config. Because the Chegg-web pipeline only builds test and
// prod envs, the function will only return test/prod/undefined. Using a build time config is
// prefered over using a runtime config.
export default function getCheggEnv() {
  return Object.values(CheggEnv).find(function (env) {
    return env === process.env.CHEGG_ENV;
  });
}